import { Formik } from 'formik';
import FormikNewTagsSearch from '../../app/components/formikComponents/FormikNewTagsSearch';
import { useEffect, useState } from 'react';
import { CustomDropdownStyle } from '../../app/components/styledComponents/StyledCustomDropdown';
import MeatballsMenuIcon from '../../app/components/svgIcons/MeatballsMenuIcon';
import styled from 'styled-components';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import {
  ButtonGroup,
  ButtonToolbar,
  Col,
  Dropdown,
  Row,
} from 'react-bootstrap';
import NewCloseIcon from '../../app/components/svgIcons/NewCloseIcon';
import StyledText from '../../app/components/styledComponents/StyledText';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ToggleContainer = styled.div`
  padding: 0 10px;
  cursor: pointer;

  svg {
    width: 25px !important;
    height: 20px !important;

    path {
      fill: ${({ theme }) => theme.primary};
      transition: fill 0.3s;
      fillopacity: 0.7;
    }
  }

  &:hover {
    svg path {
      fillopacity: 1;
    }
  }
`;

const FilterButton = styled(StyledButton)`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  height: 35px;
`;

const DropdownContainer = styled.div`
  padding: 1rem 1rem 0.5rem 1rem;

  .check-box {
    position: static !important;
  }
`;

const StyledTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  gap: 5px;
`;

const StyledTag = styled.span`
  padding: 4px 12px 4px 12px;
  color: ${({ theme, active }) => (active ? theme.white : theme.bodyMedium)};
  font-family: ${(theme) => theme.fontFamily};
  border: 1px solid ${({ theme }) => theme.dark40};
  background-color: ${({ theme, active }) =>
    active ? theme.badgeText : theme.white};
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  p {
    margin: 0;
  }
`;

const TagSelectorPopup = ({ product, isCatalogue, handleBulkEditTopTags }) => {
  const [showTagDropdown, setShowTagDropdown] = useState(false);
  const TAGS_FIELD_NAME = isCatalogue
    ? 'inventoryTagDTOS'
    : 'floristInventoryTagDTOS';
  const tags = useSelector((state) => state.productUtils.productTags);
  const [productTags, setProductTags] = useState();
  const [data, setData] = useState({
    addTagDTOS: [],
    inventoryDTOS: [],
    removeTagDTOS: [],
  });
  const productId = product?.id;
  const removeProduct = (item) => {
    // Add the product ID to inventoryDTOS if it doesn't already exist
    if (productId && !data.inventoryDTOS.includes(productId)) {
      data.inventoryDTOS.push(productId);
    }
    // Check if the item is in the product's tags
    if (product?.[TAGS_FIELD_NAME]?.some((tag) => tag.id === item.id)) {
      const { id, name } = item;
      // If the tag is in the product, remove it from addTagDTOS
      data.addTagDTOS = data.addTagDTOS?.filter((tag) => tag.id !== item.id);
      // If the tag is not in the product, add it to removeTagDTOS
      if (!data.removeTagDTOS.some((tag) => tag.id === id)) {
        data.removeTagDTOS.push({ id, name });
      }
    } else {
      // If the tag is not in the product, add it to addTagDTOS
      data.addTagDTOS = data.addTagDTOS?.filter((tag) => tag.id !== item.id);
    }
    setData(data);
  };
  const handleSubmit = async () => {
    setShowTagDropdown(false);
    const ids = product?.[TAGS_FIELD_NAME]?.map((tag) => tag.id);
    handleBulkEditTopTags({
      ...data,
      addTagDTOS: data?.addTagDTOS?.filter((tag) => !ids.includes(tag.id)),
    });
    setData({
      addTagDTOS: [],
      inventoryDTOS: [],
      removeTagDTOS: [],
    });
  };

  const handleChange = (selection, setFieldValue, item) => {
    // Add the product ID to inventoryDTOS if it doesn't already exist
    if (productId && !data.inventoryDTOS.includes(productId)) {
      data.inventoryDTOS.push(productId);
    }

    if (selection?.some((_item) => _item.id === item.id)) {
      const payload = selection?.filter((_item) => _item.id !== item.id);
      // Check if the item is in the product's tags
      if (product?.[TAGS_FIELD_NAME]?.some((tag) => tag.id === item.id)) {
        const { id, name } = item;
        // If the tag is in the product, remove it from addTagDTOS
        data.addTagDTOS = data.addTagDTOS?.filter((tag) => tag.id !== item.id);
        // If the tag is not in the product, add it to removeTagDTOS
        if (!data.removeTagDTOS.some((tag) => tag.id === id)) {
          data.removeTagDTOS.push({ id, name });
        }
      } else {
        // If the tag is not in the product, add it to addTagDTOS
        data.addTagDTOS = data.addTagDTOS?.filter((tag) => tag.id !== item.id);
      }

      setData(data);
      setFieldValue('selectedTags', payload);
    } else {
      const payload = [...selection, item];
      // If the tag is not in the product's tags, add it to addTagDTOS
      if (
        !product?.[TAGS_FIELD_NAME]?.some((tag) => tag.id === item.id) &&
        !data.addTagDTOS.some((tag) => tag.id === item.id)
      ) {
        const { id, name } = item;
        data.addTagDTOS.push({ id, name });
      }

      if (data.removeTagDTOS.some((tag) => tag.id === item.id)) {
        data.removeTagDTOS = data.removeTagDTOS?.filter(
          (tag) => tag.id !== item.id,
        );
      }
      setData(data);
      setFieldValue('selectedTags', payload);
    }
  };

  useEffect(() => {
    setProductTags(tags);
  }, [tags]);

  return (
    <CustomDropdownStyle
      autoClose={'outside'}
      menuClassName="new-menu filter-dropdown"
      className="custom-drop-down w-auto drop-down border-0 bg-transparent d-none d-md-block"
      toggleClassName={'table-dropdown ms-0 table-text p-0 border-0 new-font '}
      menuProps={{
        align: 'end',
        style: {
          minWidth: '345px',
          inset: '0 auto auto 0 !important',
          top: '-2px',
        },
      }}
      dropDownToggleProps={{
        as: 'div',
        style: {
          height: 30,
        },
      }}
      dropdownToggle={
        <ToggleContainer onClick={() => setShowTagDropdown(true)}>
          <MeatballsMenuIcon />
        </ToggleContainer>
      }
      size="small"
      dropdownMenu={
        <>
          {showTagDropdown && (
            <Formik
              enableReinitialize
              initialValues={{
                selectedTags: product?.[TAGS_FIELD_NAME] ?? [],
              }}
              onSubmit={handleSubmit}
              render={({ values, setFieldValue, handleSubmit }) => (
                <DropdownContainer>
                  <FormikNewTagsSearch
                    name="selectedTags"
                    placeholder="Select Tags"
                    options={productTags}
                    setOptions={setProductTags}
                    previousData={values}
                    secondName={'selectedTags'}
                    disableSetNameField
                    isMulti
                    removeProduct={removeProduct}
                    isFullWidth
                    onChange={(v) => {
                      if (v)
                        handleChange(values.selectedTags, setFieldValue, v);
                    }}
                  />
                  <Row className="my-2 py-2 border-top border-grey-300">
                    <StyledText
                      color="bodyMedium"
                      $fontSize="16px"
                      $fontWeight="600"
                      style={{
                        whiteSpace: 'nowrap',
                        alignSelf: 'baseline',
                      }}
                    >
                      Top Tags
                    </StyledText>
                    <StyledTagContainer>
                      {productTags
                        ?.find((item) => item.title === 'Top Tags')
                        ?.childTags?.map((tag, index) => (
                          <StyledTag
                            active={values.selectedTags?.some(
                              (item) => item.id === tag.id,
                            )}
                            key={index}
                            className="gap-3"
                            onClick={() =>
                              handleChange(
                                values.selectedTags,
                                setFieldValue,
                                tag,
                              )
                            }
                          >
                            <p>{tag.name}</p>
                            {values.selectedTags?.some(
                              (item) => item.id === tag.id,
                            ) && (
                              <NewCloseIcon
                                className={'align-self-center cursor-pointer'}
                              />
                            )}
                          </StyledTag>
                        ))}
                    </StyledTagContainer>
                  </Row>
                  <Row className="border-top border-grey-300">
                    <Col className="pt-2">
                      <ButtonToolbar className="justify-content-end">
                        <ButtonGroup className="gap-2">
                          <Dropdown.Item as={'div'} bsPrefix="none">
                            <FilterButton
                              variant={'outline'}
                              type={'button'}
                              onClick={() => {
                                setShowTagDropdown(false);
                                setFieldValue(
                                  'selectedTags',
                                  product?.[TAGS_FIELD_NAME] ?? [],
                                );
                              }}
                            >
                              Cancel
                            </FilterButton>
                          </Dropdown.Item>
                          <Dropdown.Item as={'div'} bsPrefix="none">
                            <FilterButton onClick={handleSubmit}>
                              Apply
                            </FilterButton>
                          </Dropdown.Item>
                        </ButtonGroup>
                      </ButtonToolbar>
                    </Col>
                  </Row>
                </DropdownContainer>
              )}
            />
          )}
        </>
      }
    />
  );
};

export default TagSelectorPopup;
